<div class="file-upload">
  <div class="row upload-all-files">
    <div>
      <h5 class="upload-section-text">
        {{ "quoteCheckout.upload" | cxTranslate }}
      </h5>

      <div class="col-md-7">
        <div>
          <label
            class="custom-upload"
            [ngClass]="{ 'disabled-btn': disbledBtn }"
            for="demofile-notify"
          >
            <input
              class="hidden upload-input"
              multiple
              id="demofile-notify"
              type="file"
              (change)="upload($event)"
            />
            <i class="material-icons custom-upload-icon">backup</i>
            <span> {{ "quoteCheckout.upload2" | cxTranslate }} </span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="row custom-file-format-width">
    <div class="col-md-12 custom-margin-bottom">
      <h5 class="upload-section-text custom-file-type-margin">
         {{ "quoteCheckout.upload2" | cxTranslate }}
      </h5>
    </div>
  </div>
  <div *ngIf="attachments">
    <div *ngFor="let files of attachments">
      <div class="fileDivIDUpload ml-15">
        <i class="material-icons material-icons-custom">receipt</i>
        <p id="para11">{{ files?.realFileName }}</p>
        <p id="para22">{{ getFileSize(files?.attachmentSizes) }}</p>
        <a class="closeId-img" (click)="closeFile($event, files?.mediaCode)"
          >x</a
        >
      </div>
    </div>
  </div>

  <div id="docInnerNotify" class="section-document">
    <div id="fileInfo-notify" #fileInfoNotify class="fileInfo-section"></div>
    <p
      class="section-document-document-details error-msg"
      id="fileMaxLenghtExceednotify"
      #fileMaxLenghtExceednotify
    ></p>
    <p
      id="fileSizeExceedNotify"
      #fileSizeExceedNotify
      class="section-document-document-details error-msg"
    ></p>
    <p
      id="fileTypeNotify"
      #fileTypeNotify
      class="section-document-document-details error-msg"
    ></p>
    <p
      id="fileDuplicateNotify"
      #fileDuplicateNotify
      class="section-document-document-details error-msg"
    ></p>
    <p
      id="filenameLengthNotify"
      #filenameLengthNotify
      class="section-document-document-details error-msg"
    ></p>
    <p
        id="filenameSpecialcharNotify"
        #filenameSpecialcharNotify
        class="section-document-document-details error-msg"
    ></p>
  </div>
</div>
<div class="vs-checkbox upload-checkbox" *ngIf="showCheckbox">
  <input
    id="document-upload-check"
    type="checkbox"
    (click)="getCheckBoxStatus()"
    [(ngModel)]="fileUploadCheck"
    [ngModelOptions]="{ standalone: true }"
    name="document-upload-check"
  />
  <label class="confirmation-label" for="document-upload-check"
    > {{ "quoteCheckout.confirmation" | cxTranslate }}
  </label>
</div>
